import { Pane, Text, Heading } from 'evergreen-ui';

const GRID_COLS = 'repeat(9, 1fr)';

export default function TurniStatsRecap({ statsOverview }) {
  return (
    <Pane padding={16} background="tint1">
      <Heading size={500} marginBottom={16}>Conteggio ore mensili</Heading>
      <Pane display="flex" flexDirection="column" gap={8}>
        <Pane display="grid" gridTemplateColumns={GRID_COLS} gap={8} paddingBottom={8} borderBottom="muted">
          <Text fontWeight="bold">Dipendente</Text>
          <Text fontWeight="bold">Ore contratto</Text>
          <Text fontWeight="bold">Ore assegnate</Text>
          <Text fontWeight="bold">Ore svolte</Text>
          <Text fontWeight="bold">Straordinari</Text>
          <Text fontWeight="bold">Ferie</Text>
          <Text fontWeight="bold">Permessi</Text>
          <Text fontWeight="bold">Malattia</Text>
          <Text fontWeight="bold">Reperibilità</Text>
        </Pane>
        {statsOverview.map(s => (
          <Pane key={s.uName} display="grid" gridTemplateColumns={GRID_COLS} gap={8}>
            <Text truncate>{s.uName}</Text>
            <Text>{s.oreMensiliContratto}h</Text>
            <Text>{s.expectedHours}h</Text>
            <Text color={s.expectedHours === 0 ? 'muted' : s.workedHours >= s.expectedHours ? 'success' : 'danger'} fontWeight="bold">{s.workedHours}h</Text>
            <Text>{s.overtimeHours}h</Text>
            <Text>{s.ferieHours}h</Text>
            <Text>{s.permessiHours}h</Text>
            <Text>{s.malattiaHours}h</Text>
            <Text color="purple">{s.reperibilitaHours}h</Text>
          </Pane>
        ))}
      </Pane>
    </Pane>
  );
}
